module.exports = __webpack_public_path__ + "img/wifi-oesterreich-trainerin-diplom.1a76b8c9.svg";